// extracted by mini-css-extract-plugin
module.exports = {"SectionD":"SectionD_SectionD__DkvYB"};